import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { useData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IAtividade } from '@model/Atividade';
import React from 'react';
import { AtividadeDiferencaTable } from './AtividadeDiferencaTable';

export interface IAtividadeDiferenca {
    key: string
    old: string
    new: string
}

export type AtividadeDiferencaModalProps = {
    atividade: IAtividade
    modal: IModalWindow
}

export function AtividadeDiferencaModal ({ atividade, modal}: AtividadeDiferencaModalProps) {
    const data = useData<IAtividadeDiferenca>();

    const loading = useLoading();
    const message = useMessage();

    const handleEnter = React.useCallback(() => {
        if (!loading.isLoading) {
            loading.start();

            try {
                data.clear();

                const oldObj = atividade.valoresAntigos ? JSON.parse(atividade.valoresAntigos) : {};
                const newObj = atividade.novosValores ? JSON.parse(atividade.novosValores) : {};
        
                const oldObjKeys = Object.keys(oldObj);
                const newObjKeys = Object.keys(newObj);
        
                const keySet: string[] = [];
        
                for (let i = 0; i < oldObjKeys.length; i++) {
                    const key = oldObjKeys[i];
                    
                    if (keySet.indexOf(key) === -1) {
                        keySet.push(key)
                    }
                }

                for (let i = 0; i < newObjKeys.length; i++) {
                    const key = newObjKeys[i];
                    
                    if (keySet.indexOf(key) === -1) {
                        keySet.push(key)
                    }
                }

                const sortedKeySet = keySet.sort();

                const items: IAtividadeDiferenca[] = [];
        
                for (let i = 0; i < sortedKeySet.length; i++) {
                    const key = sortedKeySet[i];
        
                    const oldValue = oldObj[key] !== undefined ? oldObj[key] : "";
                    const newValue = oldObj[key] !== undefined ? newObj[key] : "";
        
                    items.push({
                        key,
                        old: oldValue,
                        new: newValue
                    });
                }
        
                data.updateAll(items);
            }
            catch (e) {
                message.showException((e as Error)?.message);
            }
            finally {
                loading.stop();
            }
        }
    }, [atividade.novosValores, atividade.valoresAntigos, data, loading, message]);

    return (
        <ModalWindow
            modal={modal}
            disabled={false}
            size="sm"
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle
                title={`Diferenças da atividade ${atividade.atividadeId}`}
            />

            <ModalWindowContent>
                <AtividadeDiferencaTable 
                    data={data}
                />
            </ModalWindowContent>
        </ModalWindow>
    )
}